import { Button } from "@/components/ui/button"
import { useAppDispatch, useAppSelector } from "@/store"
import { benefitCreationActions as actions, creationNavigationBlocked } from "./benefitCreationSlice"

export function BenefitCreationStatus({ onOpenCreated }: { onOpenCreated: (id: string) => void }) {
  const dispatch = useAppDispatch()
  const state = useAppSelector(s => s.benefitCreation)
  const attempt = state.attempt
  const discard = () => {
    if (window.confirm("Discard the unsaved creation draft and its original confirmation? This does not delete any saved person or application.")) {
      dispatch(actions.discardConfirmed())
      requestAnimationFrame(() => document.querySelector<HTMLElement>('[data-creation-heading]')?.focus())
    }
  }
  const dirty = creationNavigationBlocked(state)
  if (!attempt && !dirty && !state.message) return null
  return <div className="space-y-3 rounded-md border p-4" role="status" aria-label="Creation status">
    <p>{attempt?.phase === "saving" ? "Creating… Keep this operation open until its result is known."
      : attempt?.phase === "confirmed" ? "Creation confirmed. Continue to the saved record; do not submit it again."
      : attempt?.phase === "abandonedUnknown" ? "Creation remains read-only. Independently verify whether the person or application was created before starting another request. A refreshed list alone does not prove the outcome."
      : state.message ?? "Unsaved creation choices are retained in this session. Finish or explicitly discard them before leaving."}</p>
    {Object.entries(state.fieldErrors).map(([field, messages]) => <p key={field} role="alert">{field}: {messages.join(" ")}</p>)}
    {(!attempt || ["rejected", "conflict"].includes(attempt.phase)) && <Button variant="outline" onClick={discard}>Discard creation draft</Button>}
    {attempt?.phase === "outcomeUnknown" && <Button variant="outline" onClick={() => dispatch(actions.unknownExitAcknowledged())}>Acknowledge unknown outcome and leave read-only</Button>}
    {attempt?.phase === "abandonedUnknown" && <Button variant="outline" onClick={() => {
      if (window.confirm("I independently verified the creation outcome. I understand starting another creation may duplicate a committed person or application. Clear this retained attempt?")) dispatch(actions.unknownResolutionAcknowledged())
    }}>I independently verified the outcome</Button>}
    {attempt?.phase === "confirmed" && attempt.resultId && <>
      <Button onClick={() => onOpenCreated(attempt.resultId!)}>Continue to saved {attempt.kind === "person" ? "person" : "application"}</Button>
      {attempt.kind === "application" && <Button variant="outline" onClick={discard}>Start a different application</Button>}
    </>}
  </div>
}
